import { FC } from 'react';
import { useTranslation } from '../../hooks/use-translation';
import { AppReviews } from '../../interfaces/domain/reviews.modal';
import SpriteIcon from '../shared/sprite-icon';
import { ProgressRing } from './progress-ring';

interface Props {
  initialReviews: AppReviews;
  onToggleOpen: () => void;
}

// -----------------------------------------------------------------------------
export const RatingsDashboard: FC<Props> = ({
  initialReviews,
  onToggleOpen,
}): JSX.Element => {
  const { t } = useTranslation();

  if (
    isNaN(initialReviews?.averageRate) ||
    !initialReviews ||
    isNaN(initialReviews?.totalRateCount) ||
    initialReviews.totalRateCount === 0
  ) {
    return null;
  }

  return (
    <div className="ratings-dashboard">
      <div className="dashboard-view">
        <div className="rating-box">
          <h3>
            <span>{initialReviews.averageRate}</span>
            <span className="best-rating">/ 5.0</span>
          </h3>
          <h4>
            <span className="reviews-amount-data">
              {initialReviews.totalRateCount}
            </span>{' '}
            {`${t('ratings')}`}
          </h4>
        </div>

        <ul className="rating-stats">
          {initialReviews.rateDistribution.map((segment) => {
            return <ProgressRing key={segment.stars} segment={segment} />;
          })}
        </ul>

        <button className="clean-btn" onClick={onToggleOpen}>
          {t('viewAll')}
          <SpriteIcon icon="arrowRight" />
        </button>
      </div>
    </div>
  );
};
